import React, { useState, ChangeEvent, useEffect } from "react";
import { Document, Page, Text, StyleSheet, PDFDownloadLink, Image, View, Font } from "@react-pdf/renderer";
import TextField from "@material-ui/core/TextField";
import { IdentityForm } from "./Certificate.style";
import { ButtonPill } from "..";
import moment from "moment";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

interface Props {
  password?: string;
  onSubmitIdentity?: (identity: IdentityFields) => any;
  backgroundImage: string;
  formationName: string;
  companyLogo: string;
  formationLogo: string;
  primaryColor: string;
  secondaryColor: string;
  pastilleCertif: string;
}

type IdentityFields = { firstName: string; lastName: string; email: string; birthdate: Date | null };
type Step = "password" | "identity" | "certificate";

const CertificateInput: React.FC<Props> = (props) => {
  const [step, setStep] = useState<Step>(props.password ? "password" : "identity");
  const [password, setPassword] = useState("");
  const [identity, setIdentyFields] = useState<IdentityFields>({
    firstName: "",
    lastName: "",
    email: "",
    birthdate: null,
  });

  useEffect(() => {
    if (password === props.password) setStep("identity");
  }, [password]);

  const onChangePassword = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPassword(event.target.value);
  };

  const onChangeBirthDate = (date: MaterialUiPickersDate) => {
    if (date) setIdentyFields({ ...identity, birthdate: date.toDate() });
  };

  const onChangeIdentityFields = (field: keyof IdentityFields) => (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setIdentyFields({ ...identity, [field]: event.target.value });
  };
  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    if (props.onSubmitIdentity) props.onSubmitIdentity(identity);
    setStep("certificate");
    event.preventDefault();
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <div>
        {step === "password" && (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <TextField label={"Mot de passe"} value={password} onChange={onChangePassword} />
          </div>
        )}
        {step === "identity" && (
          <IdentityForm onSubmit={onSubmit}>
            <TextField label={"Prénom"} value={identity.firstName} onChange={onChangeIdentityFields("firstName")} />
            <TextField label={"Nom"} value={identity.lastName} onChange={onChangeIdentityFields("lastName")} />
            <TextField label={"Email"} value={identity.email} onChange={onChangeIdentityFields("email")} />

            <KeyboardDatePicker
              disableToolbar
              format="DD/MM/YYYY"
              margin="normal"
              label="Date de naissance"
              onChange={onChangeBirthDate}
              value={identity.birthdate}
            />

            <ButtonPill style={{ marginTop: "1em" }} type="submit">
              {"Valider"}
            </ButtonPill>
          </IdentityForm>
        )}
        {step === "certificate" && (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch" }}>
            <PDFDownloadLink
              style={{ display: "flex", flexDirection: "column" }}
              document={generateDoc({
                firstName: identity.firstName,
                lastName: identity.lastName,
                backgroundImage: props.backgroundImage,
                companyLogo: props.companyLogo,
                formationLogo: props.formationLogo,
                formationName: props.formationName,
                primaryColor: props.primaryColor,
                secondaryColor: props.secondaryColor,
                pastilleCertif: props.pastilleCertif,
              })}
              fileName={"certificate.pdf"}
            >
              {({ blob, url, loading, error }) => {
                return <ButtonPill>{"Télécharger le certificat"}</ButtonPill>;
              }}
            </PDFDownloadLink>
          </div>
        )}
      </div>
    </MuiPickersUtilsProvider>
  );
};

const generateDoc = (props: {
  firstName: string;
  lastName: string;
  backgroundImage: string;
  formationName: string;
  companyLogo: string;
  formationLogo: string;
  primaryColor: string;
  secondaryColor: string;
  pastilleCertif: string;
}) => {
  Font.register({
    family: "Merriweather",
    fonts: [
      { src: process.env.PUBLIC_URL + "/fonts/Merriweather-Regular.ttf" },
      {
        src: process.env.PUBLIC_URL + "/fonts/Merriweather-Bold.ttf",
        fontWeight: "bold",
      },
    ],
  });
  const docStyles = StyleSheet.create({
    body: {
      fontFamily: "Merriweather",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    backgroundImage: {
      position: "absolute",
      minWidth: "100%",
      minHeight: "100%",
      height: "100%",
      width: "100%",
    },
    card: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-around",
      width: "95%",
      height: "95%",
      /*backgroundColor: "#FFFFFF",*/
      borderColor: props.secondaryColor,
      borderWidth: 3,
      borderStyle: "solid",
    },
    logosContainer: {
      display: "flex",
      width: "100%",
      flexDirection: "row",
      justifyContent: "space-around",

    },
    logoContainer: {
      flex: 1,
    },
    logo: {
      width: "20vw",
      height: "15vh",
    },
    logo1: {
      width: "20vw",
      height: "15vh",
      marginLeft:"55%",
    },
    pastilleCertifStyle: {
      width: "20vw",
      height: "28vh",
      bottom:"10%",
      right:"4%",
      position: "absolute",
    },
    certificateTitle: {
      fontSize: 55,
      color: props.secondaryColor,
      fontWeight: "bold",
    },
    certificateUndertitle: {
      fontSize: 25,
      color: props.secondaryColor,
      fontWeight: "bold",
      marginBottom: 5,
    },
    textContainer: {
      display: "flex",
      flexDirection: "row",
      /*width:"48%",*/
    },
    textContainerDate: {
      display: "flex",
      flexDirection: "row",
    },
    label: {
      color: props.primaryColor,
      marginHorizontal: 10,
    },
    text: {
      color: props.primaryColor,
      fontWeight: "demibold",
      textDecoration:"underline",
      textDecorationStyle:"dotted",
    },
    formationContainer: {
      padding: 5,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "95%",
      fontSize: 20,
    },
    formationIntro: {
      color: props.secondaryColor,
    },
    formationName: {
      color: props.secondaryColor,
      fontWeight: "bold",
    },
  });
  return (
    <Document>
      <Page style={docStyles.body} orientation="landscape" size="A4">
        <Image src={props.backgroundImage} style={docStyles.backgroundImage} />
        <View style={docStyles.card}>
          <View style={docStyles.logosContainer}>
            <View style={docStyles.logoContainer}>
              <Image style={docStyles.logo} src={props.companyLogo} />
            </View>
            <View style={docStyles.logoContainer}>
              <Image style={docStyles.logo1} src={props.formationLogo} />
            </View>
          </View>
          <View style={{ display: "flex", alignItems: "center" }}>
            <Text style={docStyles.certificateTitle}>{"CERTIFICAT PWP SECURE"}</Text>
            <Text style={docStyles.certificateUndertitle}>{"PROTOCOLE SANITAIRE ANIMATIONS"}</Text>
          </View>
          <Text style={docStyles.label}>{"Ce certificat de formation est attribué à :"}</Text>
          <View style={docStyles.textContainer}>
            <Text style={docStyles.label}>{"Nom :"}</Text>
            <Text style={docStyles.text}>{props.lastName}</Text>
          </View>
          <View style={docStyles.textContainer}>
            <Text style={docStyles.label}>{"Prénom :"}</Text>
            <Text style={docStyles.text}>{props.firstName}</Text>
          </View>
          <View style={docStyles.textContainerDate}>
            <Text style={docStyles.label}>{"Date d'obtention :"}</Text>
            <Text style={docStyles.text}>{moment().format("DD/MM/yyyy")}</Text>
          </View>
          <View style={docStyles.formationContainer}>
            <Text style={docStyles.formationIntro}>{"Dans le cadre de sa formation relative au bon respect des gestes barrières"}</Text>
            {/* <Text style={docStyles.formationName}>{props.formationName}</Text> */}
          </View>
          <Image style={docStyles.pastilleCertifStyle} src={props.pastilleCertif} />
        </View>
      </Page>
    </Document>
  );
};

export default CertificateInput;
